import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getNewSmsEventForm, saveSmsEvent } from "../../api/adminApi";
import LoadingPage from "../util/LoadingPage";
import { useNotification } from "../../context/NotificationContext";

const AddSmsEvent = () => {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const notify = useNotification();
  // Controlled form state
  const [priority, setPriority] = useState('');
  const [progressStatus, setProgressStatus] = useState('');
  const [smsTriggerEvent, setSmsTriggerEvent] = useState('');
  const [status, setStatus] = useState(true); // checkbox

  useEffect(() => {
    console.log("Loading SMS Event form for ID:", id);
    getNewSmsEventForm(id)
      .then((response) => {
        const data = response.data;
        setForm(data);
        setPriority(data.selectedPriority || '');
        setProgressStatus(data.selectedProgressStatus || '');
        setSmsTriggerEvent(data.selectedTriggerEvent || '');
        setStatus(data.status === 1);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading form data:", error);
        notify("error", "Failed to load SMS Event form data.");
        setLoading(false);
      });
  }, [id]);

  const handleSubmit = async () => {
    if (!smsTriggerEvent) {
      notify("error", "Trigger Event is required.");
      return;
    }

    try {
      const payload = {
        id: form.id || null, // include in edit
        organizationId: form.organizationId,
        priority: Number(priority),
        progressStatus: Number(progressStatus),
        smsTriggerEvent: smsTriggerEvent,
        status: status ? 1 : 0,
      };

      await saveSmsEvent(payload);
      notify("success", "SMS Event saved successfully!");
    } catch (err) {
      console.error("Save error:", err);
      notify("error", "Failed to save SMS Event.");
    }
  };

  if (loading) return <LoadingPage />;
  if (!form) return <div className="text-red-500 p-4">Failed to load form data.</div>;

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-semibold mb-6 border-b pb-2">Add SMS Event</h1>

      <div className="bg-white p-6 rounded-lg shadow border space-y-4">
        {/* Trigger Event */}
        <div>
          <label className="block font-medium mb-1">Trigger Event</label>
          <select
            value={smsTriggerEvent}
            onChange={(e) => setSmsTriggerEvent(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option value="" disabled>Select Trigger Event</option>
            {form.smsTriggerEventList.map((item) => (
              <option key={item.key} value={item.value}>{item.value}</option>
            ))}
          </select>
        </div>

        {/* Priority */}
        <div>
          <label className="block font-medium mb-1">Priority</label>
          <select
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            {form.priorityList.map((item) => (
              <option key={item.key} value={item.key}>{item.value}</option>
            ))}
          </select>
        </div>

        {/* Progress Status */}
        <div>
          <label className="block font-medium mb-1">Progress Status</label>
          <select
            value={progressStatus}
            onChange={(e) => setProgressStatus(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            {form.progressStatusList.map((item) => (
              <option key={item.key} value={item.key}>{item.value}</option>
            ))}
          </select>
        </div>

        {/* Active / Inactive */}
        <div className="flex items-center">
          <input
            id="status"
            type="checkbox"
            checked={status}
            onChange={(e) => setStatus(e.target.checked)}
            className="mr-2"
          />
          <label htmlFor="status">Active</label>
        </div>

        {/* Save */}
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSmsEvent;
